import { Validator, isRequired, validateEmailFormat } from '../../../common/hooks/useFormControls';

const requiredField = Validator(isRequired, 'This field is required');
const validEmail = Validator(validateEmailFormat, 'Please enter a valid email address');
const trimWhitespace = (value) => value.trim();

const billingContactForm = [
  {
    fieldName: 'billingContactName',
    value: '',
    sanitizers: [trimWhitespace],
  },
  {
    fieldName: 'billingContactEmail',
    value: '',
    sanitizers: [trimWhitespace],
  },
  {
    fieldName: 'acceptTermsCheckbox',
    value: '',
    sanitizers: [],
    validators: [requiredField],
  },
];

const updateBillingContactValidators = (fieldsVisible, setValidators, resetForm) => {
  if (fieldsVisible) {
    setValidators('billingContactName', [requiredField]);
    setValidators('billingContactEmail', [requiredField, validEmail]);
  } else {
    resetForm();
  }
};

export { billingContactForm, updateBillingContactValidators };
